import styles from "../link-report.module.scss";
export function Elide(props) {
    return <div {...props} className={styles.elide} />;
}
